import React from 'react';
import { ProductTransactionExportConfiguration } from '../types/product_transaction_export_configuration';

export interface ProductTransactionExportConfigurationContextProps {
  productTransactionExportConfigurations: Map<string, ProductTransactionExportConfiguration>;
  setProductTransactionExportConfigurations: (
    productMasterData: Map<string, ProductTransactionExportConfiguration>,
  ) => void;
  productTransactionExportConfigurationsLoading: boolean;
}

const defaultContext: ProductTransactionExportConfigurationContextProps = {
  productTransactionExportConfigurations: new Map(),
  setProductTransactionExportConfigurations: () => {},
  productTransactionExportConfigurationsLoading: false,
};

export const ProductTransactionExportConfigurationContext =
  React.createContext<ProductTransactionExportConfigurationContextProps>(defaultContext);
